import { messages } from './DropdownSections.messages';
import { DropdownSectionsProps } from './DropdownSections.types';

export const getActivatorName = (value: DropdownSectionsProps['value'], items: DropdownSectionsProps['items']) => {
    return items?.find(({ to }) => to === value)?.name || messages.defaultDropdownName;
};
